import emailjs from '@emailjs/browser'
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useRef } from 'react'
import toast, { Toaster } from 'react-hot-toast'

const Contact = () => {
    const form = useRef()

    const sendEmail = e => {
        e.preventDefault()
        emailjs.sendForm('service_ga9qp4h', 'template_0eob4sg', form.current, 'I1sHJr80d0AeFwUhr').then(
            result => {
                toast.success('Email sent')
            },
            error => {
                toast.error('Try later!')
            }
        )
        e.target.reset()
    }

    return (
        <div
            id="contact"
            className="max-w-7xl mx-auto my-20 lg:px-10 text-center"
            data-aos="fade-up"
            data-aos-duration="3000"
        >
            <h2 class="text-4xl text-warning font-bold">Get In Touch</h2>
            <div className="text-success">
                <p className="my-2">
                    <FontAwesomeIcon icon={faPhone} /> Phone: +880 1682596304
                </p>
                <p className="my-2">
                    <FontAwesomeIcon icon={faEnvelope} /> Email: forhad.uddin164@gmail.com
                </p>
                <p className="my-2">
                    LinkedIn:{' '}
                    <a href="https://www.linkedin.com/in/forhad-uddin1">https://www.linkedin.com/in/forhad-uddin1</a>
                </p>
            </div>

            <form
                ref={form}
                onSubmit={sendEmail}
                className="mt-10 px-6 lg:px-10"
                action="https://form.jotform.com/221591058633456"
            >
                <div className="grid lg:grid-cols-2 gap-4">
                    <div className="grid grid-cols-1 gap-4">
                        <input
                            name="name"
                            type="text"
                            placeholder="Your name"
                            class="input input-bordered input-primary lg:text-lg w-full"
                            required
                        />
                        <input
                            name="email"
                            type="email"
                            placeholder="Email"
                            class="input input-bordered input-primary lg:text-lg w-full"
                            required
                        />
                    </div>

                    <textarea
                        name="message"
                        class="textarea textarea-primary w-full h-full lg:text-lg"
                        placeholder="Message"
                        required
                    ></textarea>
                </div>
                <button type="submit" class="btn btn-secondary mt-6">
                    Send Message
                </button>
            </form>
            <Toaster />
        </div>
    )
}

export default Contact
